import type { FaireProductEntity } from "../../entity_types/product";

export const p_h8drcsm45b: FaireProductEntity = {
  token: "p_h8drcsm45b",
  type: "product",
  name: "DRNX AWT Mango Turmeric Water (16.9oz) (12-Pack)",
  brandToken: "b_qvgnvkj5hp",
  brandName: "AI Distribution",
  imageUrl:
    "https://cdn.faire.com/fastly/0dc30eed16e81e01f1b0a14e6cf417738806797d209f1b019f5c06cdc121afdb.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cabdedef8e5867fc8f739de456265d9923a1c9158dcd9886d85043d6222f32fe.png",
    "https://cdn.faire.com/fastly/19bb457bf43ec27341e6893d3e9113c3d11badc65666a2ddbbdd0181e28ed63f.png",
  ],
  priceDollars: 33.09,
  description:
    "Tropical mango meets golden turmeric in this smooth, sunshine-packed blend that tastes as good as it feels. DRNX Mango Turmeric is your go-to for daily balance — combining antioxidant-rich ingredients and adaptogens to help fight inflammation, support recovery, and keep you moving.",
  tags: [],
  msrpDollars: 66.18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:21.146Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
